var baseUrl = 'https://course-track.sanyokmalyshev.workers.dev/CourseTracker';

module.exports = { baseUrl };